const utils = require("frontend-controller/lib/utils")
module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 40,
		preventSortOfField: {
			tags: true,
		},
		buttonContext: 'members',
		// showHead: false,
		// showInsertButton: false,
		// renderEmptyBeforReady: true,
		rowActionsInline: true,
		inline: true,
		rowActions: {
			delete: true,
			// edit: true,
			// customs: []
		},
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'memberID',
				direction: 'desc'
			}]
		}
	},

	methods: {

		addEntity: function(entity){
			// add entity to dom if necessary
			if(this.config.isReady && this.model.$table){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }))
			}
		},

		showInsert: function(){
			const baseActionKey = 'showInsert_member';
			return this.performAndStoreAction(
				baseActionKey + '_inEffect',
				this.prepareAction(baseActionKey),
				true
			)
		},

		showEdit: function(rowID, rowData){
			const baseActionKey = 'showEdit_member';
			return this.performAndStoreAction(
				baseActionKey + '_inEffect',
				this.prepareAction(baseActionKey, undefined, {
					memberProperties: {
						resourceID: rowID,
					},
				}),
				true
			)
		},

		// delete: function(rowID, rowData){
		// 	if(rowID){
		// 		return this.performAction(this.prepareAction('delete_member', rowID))
		// 	}
		// },

		delete: function(rowID, rowData){
			if(rowID) {
				return this.performDecision(
					'confirm',
					{
						component: this,
						title: storage.__('hint.delete.really.members.title'),
						message: storage.__('hint.delete.really.members.message')
					}
				).then(context => {
					if (context.decision.type === 'yes') {
						return this.performAction(this.prepareAction('delete_member', rowID))
							.then(() => {
								this.refreshData(true)
							})
					}

					return utils.promise.reject()
				});
			}
		},
	},

	hooks: {
		attach: function($element, options){
			if(!this.model.controller){
				this.closest('templates_livecom_members_controller', controller =>{
					this.model.controller = controller
				})
			}

			this.model.$table = $element.find('table');
		},

		async onDecision($element, options){
			// TODO: FEATURE: THIS IS AN NEW ASYNC FORMAT EXAMPLE FOR onDecision hooks
			if(!options.decisionComponent.hasClass('base_modal_modal')) {
				return
			}

			const modal = options.decisionComponent

			if(options.decisionType === 'cancel'){
				return modal.hide()
			}

			let form
			if(modal.hasClass('container_templates_propertiesForms_memberPropertiesForm')){
				modal.find('templates_propertiesForms_memberPropertiesForm', c => form = c)
			}

			if(form){
				await form.submit()
			}
			await modal.hide()
			if(form){
				await this.refreshData(true)
			}
		},
	},
}